import { createContext } from 'react';

import { Call } from '@twilio/voice-sdk';

import { AudioDeviceActive, AudioDeviceOptions, MyPhoneCall } from '../../types';

export type TwilioDeviceStatus = 'disconnected' | 'connecting' | 'connected';
export type BackendAgentStatus = 'offline' | 'online' | 'dial-only' | 'on-a-call';

export type TwilioContextType = {
  connect: (
    identity: string,
    phoneNumber: string,
    connectionType?: 'online' | 'dial-only'
  ) => void;
  disconnect: () => void;
  status: TwilioDeviceStatus;
  agentStatus: BackendAgentStatus;
  isStatusLocked: boolean;
  setStatus(status: TwilioDeviceStatus): void;
  setSpeakerDevice(deviceId: string): Promise<void>;
  setRingtoneDevice(deviceId: string): Promise<void>;
  calls: Call[];
  currentCall?: Call;
  setCurrentCall: (call: Call) => void;
  selectedHistoricalCall?: MyPhoneCall;
  setSelectedHistoricalCall: (call: MyPhoneCall | undefined) => void;
  makeCall(to: string): Promise<Call | undefined>;
  forwardCall(call: Call): Promise<Call>;
  availableDevices: AudioDeviceOptions;
  activeDevices: AudioDeviceActive;
};

export const TwilioContext = createContext<TwilioContextType>();
